import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {cn} from '@/lib/utils'

export const PreviewContainer = ({children, type}) => {
    const typeMap = {
        Guest: {
            borderColor: 'border-active',
            bgColor: 'bg-active',
            textColor: 'text-black'
        },
        Auth: {
            borderColor: 'border-error',
            bgColor: 'bg-error',
            textColor: 'text-white'
        },
        'LMN Allowed': {
            borderColor: 'border-blue-500',
            bgColor: 'bg-blue-500',
            textColor: 'text-white'
        },
        'LMN Suppressed': {
            borderColor: 'border-green-500',
            bgColor: 'bg-green-500',
            textColor: 'text-white'
        }
    }

    const {borderColor, bgColor, textColor} = typeMap[type]
    const labelRef = useRef(null)
    const [isOverflowing, setIsOverflowing] = useState(false)

    useEffect(() => {
        let timeoutId

        const checkOverflow = () => {
            if (labelRef.current) {
                const {scrollWidth, clientWidth} = labelRef.current
                const overflow = scrollWidth > clientWidth

                if (overflow !== isOverflowing) {
                    setIsOverflowing(overflow)
                }
            }
        }

        const debouncedResizeHandler = () => {
            clearTimeout(timeoutId)
            timeoutId = setTimeout(checkOverflow, 150)
        }

        checkOverflow()
        window.addEventListener('resize', debouncedResizeHandler)

        return () => {
            clearTimeout(timeoutId)
            window.removeEventListener('resize', debouncedResizeHandler)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const warningMessage = `⚠️ ${type}-Only Content`

    return (
        <div
            className={cn('border-solid border-4 bg-yellow-100 relative', borderColor)}
            title={warningMessage}
        >
            <div
                ref={labelRef}
                className={cn(
                    'p-0 font-medium text-sm absolute top-0 right-0 text-center shadow-md opacity-75',
                    'truncate cursor-pointer invisible',
                    bgColor,
                    textColor,
                    {'w-full visible': !isOverflowing}
                )}
            >
                {!isOverflowing && warningMessage}
            </div>
            <div>{children}</div>
        </div>
    )
}

PreviewContainer.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string.isRequired
}
